import { z } from 'zod'
import { AuditTokenSchema } from '../schemas'
import { http } from './http'
import { parseWithZod } from '../utils/parse-with-zod'

const EditTokenResponseSchema = AuditTokenSchema.pick({
  id: true,
  is_disabled: true,
  name: true,
  description: true,
})

const TokenListResponseSchema = z.array(AuditTokenSchema)

const GenerateTokenResponseSchema = AuditTokenSchema.extend({
  access_token: z.string(),
})

type EditTokenPayload = {
  name: string
  description: string
  isDisabled: boolean
}

type GenerateTokenPayload = {
  name: string
  description: string
  isDisabled: boolean
  validity: number
}

export const tokens = {
  edit: async (
    tokenId: number,
    { isDisabled: is_disabled, name, description }: EditTokenPayload,
  ) => {
    const result = await http.post(`/api/v1/user_issued_tokens/${tokenId}/edit`, {
      is_disabled,
      name,
      description,
    })

    return parseWithZod(EditTokenResponseSchema, result)
  },
  delete: async (tokenId: number) => {
    return await http.delete(`/api/v1/user_issued_tokens/${tokenId}`)
  },
  generate: async ({
    name,
    description,
    isDisabled: is_disabled,
    validity: lifetime_days,
  }: GenerateTokenPayload) => {
    const result = await http.post('/api/v1/user_issued_tokens/obtain', {
      name,
      description,
      is_disabled,
      lifetime_days,
    })

    return parseWithZod(GenerateTokenResponseSchema, result)
  },
  getAll: async () => {
    const result = await http.get('/api/v1/user_issued_tokens')
    return parseWithZod(TokenListResponseSchema, result)
  },
  regenerate: async (
    tokenId: number,
    {
      isDisabled: is_disabled,
      validity: lifetime_days,
    }: {
      isDisabled: boolean
      validity: number
    },
  ) => {
    const result = await http.post(`/api/v1/user_issued_tokens/${tokenId}/regenerate`, {
      is_disabled,
      lifetime_days,
    })

    return parseWithZod(GenerateTokenResponseSchema, result)
  },
}
